import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class LanguageAssessmentType extends AbstractModel {
  @autoserialize
  assessmentSlug: string;

  @autoserialize
  screeningPackageId: number;

  @autoserialize
  active: boolean;
}
